import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from '../hooks/useAuth';
import Constants from '../constants/Constants';
import AppRoutes from '../constants/AppRoutes';
import Login from '../pages/login/login';
import Home from '../pages/home/home';
import Cart from '../pages/cart/cart';
import Profile from '../pages/profile/profile';
import OrderConfirmation from '../pages/order-confirmation/order-confirmation';
import ProtectedRouter from './protected-router';
import AuthenticationService from '../services/authentication-service';
import ForgotPassword from '../pages/forgot-password/forgot-password';
import ResetPassword from '../pages/reset-password/reset-password';

const AppRouter = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { authLogin } = useAuth();

    /** ---------------------------------------------------------------
     * Method : loadDefaultExperience
     * Description : navigate user based on the role
     */
    const loadDefaultExperience = (userRole) => {
        if(userRole === Constants.USER_ROLES.EMPLOYEE) {
            if(location.pathname === AppRoutes.ROOT || location.pathname === AppRoutes.LOGIN) {
                navigate(AppRoutes.HOME);
            } else {
                navigate(location.pathname);
            }
        } else if(userRole === Constants.USER_ROLES.VENDOR) {
            navigate(AppRoutes.PROFILE);
        } else {
            navigate(AppRoutes.LOGIN);
        }
    };

    useEffect(() => {
        (async () => {
            const {isValidSession, userDetails} = await AuthenticationService.checkIfValidSession();
            if(isValidSession) {
                loadDefaultExperience(userDetails.userRole);
                authLogin();
            }
        })();
    }, []);

    return (
        <Routes>
            <Route index element={<Login />} />
            <Route path={AppRoutes.LOGIN} element={<Login />} />
            <Route path={AppRoutes.FORGOT_PASSWORD} element={<ForgotPassword />} />
            <Route path={AppRoutes.RESET_PASSWORD} element={<ResetPassword />} />
            <Route path={AppRoutes.HOME} element={
                <ProtectedRouter>
                    <Home />
                </ProtectedRouter>
            } />
            <Route path={AppRoutes.CART} element={
                <ProtectedRouter>
                    <Cart />
                </ProtectedRouter>
            } />
            <Route path={AppRoutes.PROFILE} element={
                <ProtectedRouter>
                    <Profile />
                </ProtectedRouter>
            } />
            <Route path={AppRoutes.ORDER_CONFIRM} element={
                <ProtectedRouter>
                    <OrderConfirmation />
                </ProtectedRouter>
            } />
            <Route path="*" element={<Login />} />
        </Routes>
    )
}
export default AppRouter;